// extracted by mini-css-extract-plugin
export default {"container":"DataUpdateIndicator_container__viBr7","icon":"DataUpdateIndicator_icon__H7CV9","updateMessage":"DataUpdateIndicator_updateMessage__YSvyA"};